// namespace:
var agi = agi || {};
agi.expressions = agi.expressions || {};

/**
 * ExpressionBCVideo is responsible to play a
 * BrightCove video as part of the expression product
 * degradation plan.
 *
 */
agi.expressions.ExpressionBCVideo = (function(Utils) {
    "use strict";

    var brightCoveUrl = "http://admin.brightcove.com/js/BrightcoveExperiences.js";
    var env, product, container, player, modVP;
    var isOldIE;

    function init(envJson, productJson, expressionInstance) {
        env = envJson;
        product = productJson;
        Utils.loadJavaScriptFile(brightCoveUrl, successHandler.bind(this),
                                      failedHandler.bind(this));

        var ieVersion = parseInt(env.isIE);
        isOldIE = (ieVersion > 0) && (ieVersion < 11);
        var originalContainerId = env["expressionContainer"];
        container = document.createElement('div');
        container.className = "expression-video-fallback-wrapper";
        document.getElementById(originalContainerId).appendChild(container);
    };

    function successHandler() {
        var vidPlayerObjectTag = env["BCVidPlayerObjectTag"];
        container.innerHTML = vidPlayerObjectTag;
        brightcove.createExperiences();
    };

    function failedHandler() {
        alert("Sorry, an unexpected error occurred. Please try again");
    };

    //ie9 has no key-frame animation support, iPhone has support for it
    function showMsgs() {
        if (isOldIE) {
            document.querySelector("#expression-user-message").style.opacity = 1;
            document.querySelector("#expression-user-message").style.visibility = "visible";
            document.querySelector("#expression-jl-caption").style.visibility = "visible";
        } else {
            document.querySelector("#expression-user-message").style.visibility = "visible";
            Utils.addClass(document.querySelectorAll("#expression-user-message"),
                                    "expression-oneSecondFadeIn");
            document.querySelector("#expression-jl-caption").style.visibility = "visible";
        }
    };

    function hideMsgs() {
        if (isOldIE) {
            document.querySelector("#expression-user-message").style.opacity = 0;
            document.querySelector("#expression-user-message").style.visibility = "hidden";
            document.querySelector("#expression-jl-caption").style.visibility = "hidden";
        } else {
            document.querySelector("#expression-user-message").style.visibility = "hidden";
            Utils.removeClass(document.querySelectorAll("#expression-user-message"),
                                                        "expression-oneSecondFadeIn");
            document.querySelector("#expression-jl-caption").style.visibility = "hidden";
        }
    };

    function on_media_begin() {
        console.log('media has begun playback initially');
    };

    function on_media_play() {
        console.log('media has begun or resumed playback');
    };

    function on_media_complete(evt) {
        console.log('media complete');
        showMsgs();
    };

    function on_media_progress(evt) {
        console.log('media progress ' + evt.position);
        if (evt.position < 5) {
            hideMsgs();
        } else if (evt.position > 20) {
            showMsgs();
        }
    };

    function onBCTemplateLoad(experienceID) {
        console.log("BC template loaded ", experienceID);
        player = brightcove.api.getExperience(experienceID)
        modVP = player.getModule(brightcove.api.modules.APIModules.VIDEO_PLAYER);
    };

    function onBCTemplateReady(evt) {
        console.log("BC template ready ", evt);
        modVP.getCurrentVideo(function (data) {
        });
        modVP.addEventListener(brightcove.api.events.MediaEvent.BEGIN, on_media_begin.bind(this));
        modVP.addEventListener(brightcove.api.events.MediaEvent.PLAY, on_media_play.bind(this));
        modVP.addEventListener(brightcove.api.events.MediaEvent.PROGRESS, on_media_progress.bind(this));
        modVP.addEventListener(brightcove.api.events.MediaEvent.COMPLETE, on_media_complete.bind(this));
    };

    return {
        init: init,
        onBCTemplateLoad: onBCTemplateLoad,
        onBCTemplateReady: onBCTemplateReady
    }

})(agi.expressions.Utils);
